import React from 'react'
import "pages/Styles/UIKit_v2.sass"
import "pages/Styles/Cells.sass"

interface IntegrationCardProps {
    title: string
    description: string
    icon?: React.ReactNode
    onDetails: () => void
    detailsLabel?: string
    onPrimary?: () => void
    primaryLabel?: string
}

export default function IntegrationCard({
    title,
    description,
    icon,
    onDetails,
    detailsLabel = "Подробнее",
    onPrimary,
    primaryLabel = "Настроить"
}: IntegrationCardProps) {
    return (
        <div className="cell-card ui-kit-v2 integration-card">
            <div className="integration-card__header">
                <div className="integration-card__icon">
                    {icon}
                </div>
                <div className="Subtitle_18 integration-card__title">{title}</div>
            </div>
            <div className="cell-card-meta integration-card__description">{description}</div>
            <div className="integration-card__actions">
                <button className="new action-button secondary" onClick={onDetails}>
                    <span className="button-text">{detailsLabel}</span>
                </button>
                {onPrimary && (
                    <button className="new action-button primary" onClick={onPrimary}>
                        <span className="button-text">{primaryLabel}</span>
                    </button>
                )}
            </div>
        </div>
    )
} 